export type TOrientacaoTela = 'portrait' | 'landscape' | 'landscape-primary' | '-';

export default class WindowUtils {
  static async aceitaMudarOrientacao(): Promise<boolean> {
    let lErroAoTentarUsarApi = '';
    const lMensagemDispositivoIncompativel =
      'NotSupportedError: screen.orientation.lock() is not available on this device.';

    try {
      await screen.orientation.lock('portrait');
    } catch (error) {
      lErroAoTentarUsarApi = String(error);
    }

    if (lErroAoTentarUsarApi.includes(lMensagemDispositivoIncompativel)) {
      console.warn(`[ALERTA] - O dispositivo não aceita mudança de orientação. Detalhes: ${lErroAoTentarUsarApi}`);
      return false;
    }

    return true;
  }

  static async definirOrientacao(pOrientacao: TOrientacaoTela): Promise<TOrientacaoTela> {
    if (!(await WindowUtils.aceitaMudarOrientacao())) {
      return '-';
    }

    await document.documentElement.requestFullscreen();
    await screen.orientation.lock(pOrientacao);

    return pOrientacao;
  }

  static fullscren(pAtivar: boolean) {
    const element = document.documentElement;

    if (pAtivar) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
        // } else if (element.mozRequestFullScreen) {
        //   element.mozRequestFullScreen();
        // } else if (element.webkitRequestFullscreen) {
        //   element.webkitRequestFullscreen();
        // } else if (element.msRequestFullscreen) {
        //   element.msRequestFullscreen();
        //
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        // } else if (document.mozCancelFullScreen) {
        //   document.mozCancelFullScreen();
        // } else if (document.webkitExitFullscreen) {
        //   document.webkitExitFullscreen();
        // } else if (document.msExitFullscreen) {
        //   document.msExitFullscreen();
        //
      }
    }

    return pAtivar;
  }
}
